// stringify class or instance of a class
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
export function stringifyClass(token: object | Function | undefined): string {
  if (typeof token === 'object') {
    return token.constructor.name;
  }
  if (token == null) {
    // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
    return '' + token;
  }
  return token.name;
}
